import React from 'react';

export default function Icon({ kind = 'arrow', className = '' }) {
  const paths = {
    arrow: 'M4 12h15M13 5l7 7-7 7',
    diagonal: 'M5 19L19 5M5 5h14v14',
    down: 'M12 4v16M5 13l7 7 7-7',
    download: 'M12 3v12M7 10l5 5 5-5M4 16v5h16v-5',
    plus: 'M12 4v16M4 12h16',
    close: 'M5 5l14 14M5 19L19 5',
    menu: 'M4 7h16M4 17h16',
    back: 'M20 12H4M11 5l-7 7 7 7',
  };
  return <svg className={`icon ${className}`} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d={paths[kind] || paths.arrow} /></svg>;
}
